function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { NumericFormat } from 'react-number-format';
import { ICON_CURRENCY_EUR } from '../../icons';
import Input from '../input/Input';
export const DecimalPriceField = _ref => {
  let {
    name,
    value,
    icon = ICON_CURRENCY_EUR,
    onChange,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(NumericFormat, _extends({}, rest, {
    name: name,
    value: value,
    valueIsNumericString: true,
    decimalScale: 2,
    thousandSeparator: ".",
    decimalSeparator: ",",
    allowNegative: false,
    customInput: Input,
    icon: icon,
    onValueChange: values => {
      if (onChange) {
        onChange({
          target: {
            name,
            value: values.value
          }
        });
      }
    }
  }));
};
//# sourceMappingURL=DecimalPriceField.js.map